import styled from "styled-components";

export const Box = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Container = styled.div`
  display: flex;
  flex: 1;
  background-color: #f4f4fd;
`;

export const Div = styled.div`
  padding: 3px 0;
  margin-right: 3px;
  display: flex;
  flex: 1;
`;
